

import * as React from 'react';

const Ruler = () => (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.38465 34.9999C7.60035 34.9999 6.9235 34.7152 6.3541 34.1458C5.7847 33.5764 5.5 32.8974 5.5 32.1089V15.891C5.5 15.1201 5.7847 14.4455 6.3541 13.8673C6.9235 13.2891 7.60035 13 8.38465 13H40.6153C41.3996 13 42.0764 13.2891 42.6458 13.8673C43.2152 14.4455 43.4999 15.1201 43.4999 15.891V32.1089C43.4999 32.8974 43.2152 33.5764 42.6458 34.1458C42.0764 34.7152 41.3996 34.9999 40.6153 34.9999H8.38465ZM8.38465 32.7307H40.6153C40.7691 32.7307 40.9102 32.6666 41.0384 32.5384C41.1666 32.4102 41.2307 32.2691 41.2307 32.1153V15.8846C41.2307 15.7308 41.1666 15.5897 41.0384 15.4615C40.9102 15.3333 40.7691 15.2692 40.6153 15.2692H34.3653V23.2307H32.0961V15.2692H25.6346V23.2307H23.3654V15.2692H16.9038V23.2307H14.6346V15.2692H8.38465C8.23078 15.2692 8.08973 15.3333 7.9615 15.4615C7.8333 15.5897 7.7692 15.7308 7.7692 15.8846V32.1153C7.7692 32.2691 7.8333 32.4102 7.9615 32.5384C8.08973 32.6666 8.23078 32.7307 8.38465 32.7307Z" fill="#2A2A2A"/>
    </svg>

);

export default Ruler;



